<template>
  <span>
    <button class="btn btn-success"
            @click="showCreateIncidentModal"
    >
      <font-awesome-icon icon="plus-circle"/>
      {{ $t('maintenance.incidents.create_button') }}
    </button>

    <!-- Create Incident modal template -->
    <b-modal ref="create-incident" @hide="hideCreateIncidentModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateIncidentModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-m-title">
            {{ $t('maintenance.incidents.create.title') }}
          </h5>
          <div class="row mt-2 pt-4 pb-1" v-if="getGuide('create_incident')">
            <div class="col-sm-12">
              <b-form-group>
                <div class="">
                  <label qid="create-p-users-label">
                    <font-awesome-icon icon="info-circle"/>
                    {{ $t('system.help_center_label') }}
                  </label>
                  <div v-if="wpGuide && wpGuide.id" class="guide-content-container">
                    <p v-if="!showFullGuideDescription" v-html="wpGuide.excerpt.rendered"></p>
                    <p v-if="showFullGuideDescription" v-html="wpGuide.content.rendered"></p>

                    <div class="text-center mt-3" @click="showFullGuideDescription=!showFullGuideDescription">
                      <span class="cursor-pointer" v-if="!showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-m-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="createIncidentFormSubmit" qid="create-m-form" class="mt-3">
        <!-- First page  -->
        <div v-if="position == 1">
          <b-form-group>
            <label qid="create-m-category-label">
              {{ $t('maintenance.incidents.create.category_label') }}
            </label>
            <multiselect
                v-model="selectedIncidentCategory"
                :options="incidentCategoryItems"
                :placeholder="$t('maintenance.incidents.create.category_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="loadIncidentCategories"
                track-by="slug"
                qid="create-ac-form-ac"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedIncidentCategory && selectedIncidentCategory.id">
            <div class="">
              <div v-if="selectedIncidentCategory.description && selectedIncidentCategory.description.length > 300">
                <p v-if="showFullDescription" class="text-formatted">
                  {{ selectedIncidentCategory.description }}
                </p>
                <p v-if="!showFullDescription" class="text-formatted">
                  {{ selectedIncidentCategory.description | truncate(300) }}
                </p>
                <div class="text-center mt-3" @click="showFullDescription=!showFullDescription">
                  <span class="cursor-pointer" v-if="!showFullDescription">
                    <span class="mr-2">
                      {{ $t('system.view_more') }}
                    </span>
                    <font-awesome-icon icon="chevron-down"/>
                  </span>
                  <span class="cursor-pointer" v-if="showFullDescription">
                    <span class="mr-2">
                      {{ $t('system.view_less') }}
                    </span>
                    <font-awesome-icon icon="chevron-up"/>
                  </span>
                </div>
              </div>
              <p v-if="selectedIncidentCategory.description && selectedIncidentCategory.description.length <= 300"
                 class="text-formatted"
              >
                {{ selectedIncidentCategory.description }}
              </p>
            </div>
          </b-form-group>
        </div>
        <!-- Second page -->
        <div v-if="position == 2">
          <b-form-group>
            <label qid="create-m-name-label">
              {{ $t('maintenance.incidents.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
              qid="create-m-form-name"
              type="text"
              v-model="form.short_name"
              required
              :maxLength="255"
              :placeholder="$t('maintenance.incidents.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>

          <b-form-group v-if="selectedIncidentCategory && selectedIncidentCategory.add_description && selectedIncidentCategory.add_description == 'Optional' || selectedIncidentCategory.add_description == 'Mandatory'">
            <label qid="create-m-description-label">
              {{ $t('maintenance.measures.create.description_label') }}
              <span class="text-red" v-if="selectedIncidentCategory && selectedIncidentCategory.add_description == 'Mandatory'">*</span>
            </label>
            <b-form-textarea
              qid="create-m-form-description"
              v-model="form.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.measures.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <div class="mt-2" v-if="selectedIncidentCategory && selectedIncidentCategory.add_attachments && selectedIncidentCategory.add_attachments == 'Optional' || selectedIncidentCategory.add_attachments == 'Mandatory'">
            <label>
              {{ $t('maintenance.policies.create.attachments') }}
              <span class="text-red" v-if="selectedIncidentCategory && selectedIncidentCategory.add_attachments == 'Mandatory'">*</span>
              &nbsp;
              <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
            </label>
            <br>
          </div>

          <b-form-group v-if="selectedIncidentCategory && selectedIncidentCategory.add_attachments && selectedIncidentCategory.add_attachments == 'Optional' || selectedIncidentCategory.add_attachments == 'Mandatory'">
            <label qid="create-tp-link-label">
              {{ $t('maintenance.third_parties.create.links_label') }}
              <span class="text-red" v-if="selectedIncidentCategory && selectedIncidentCategory.add_attachments == 'Mandatory'">*</span>
            </label>
            <p v-for="(link, index) in form.links">
              <span class="float-right text-muted cursor-pointer"
                    @click="removeLinkItem(index)"
                    qid="create-tp-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <a :href="link.url" target="_blank" qid="create-p-link-item">{{ link.name ? link.name : link.url }}</a>
            </p>
            <div>
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLink"
                :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                qid="create-p-links"
              ></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLinkName"
                :placeholder="inputLink ? inputLink : $t('table.name')"
                qid="create-p-links"
              ></b-form-input>
            </div>
            <span class="btn btn-link cursor-pointer float-right"
                  @click="handleLink"
                  qid="create-tp-add-link"
            >
              + {{ $t('system.add_link') }}
            </span>
          </b-form-group>

          <!-- If not anonymous -->
          <div v-if="selectedIncidentCategory && selectedIncidentCategory.id && !selectedIncidentCategory.anonymous" class="mt-3">
            <b-form-group>
              <label qid="create-m-name-label">
                {{ $t('maintenance.incidents.create.name_reporter_label') }}<span class="mandatory"> *</span>
              </label>
              <b-form-input
                qid="create-m-form-name"
                type="text"
                v-model="form.name"
                required
                :maxLength="255"
                :placeholder="$t('maintenance.incidents.create.name_reporter_placeholder')"
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <label qid="create-m-name-label">
                {{ $t('maintenance.incidents.create.email_label') }}<span class="mandatory"> *</span>
              </label>
              <b-form-input
                qid="create-m-form-name"
                type="email"
                v-model="form.email"
                required
                :maxLength="255"
                :placeholder="$t('maintenance.incidents.create.email_placeholder')"
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <label qid="create-m-name-label">
                {{ $t('maintenance.incidents.create.phone_label') }}<span class="mandatory"> *</span>
              </label>
              <b-form-input
                qid="create-m-form-name"
                type="text"
                v-model="form.phone"
                required
                :maxLength="255"
                :placeholder="$t('maintenance.incidents.create.phone_placeholder')"
              ></b-form-input>
            </b-form-group>
          </div>

        </div>

        <!-- Questions page  -->
        <div v-if="position == 3">
          <div v-if="selectedQuestion && selectedQuestion.id">
            <label for="">
              {{ selectedQuestion.name }}
            </label>

            <p class="text-formatted">{{selectedQuestion.description }}</p>

            <div class="mt-4">

              <label qid="create-m-name-label">
                {{ $t('maintenance.incidents.create.response_label') }}
                <span class="mandatory" v-if="selectedQuestion.mandatory_type && selectedQuestion.mandatory_type == 'Mandatory'"> *</span>
              </label>

              <div v-if="selectedQuestion.response_type == 'Single line text'">
                <b-form-input
                  qid="create-m-form-name"
                  type="text"
                  v-model="selectedQuestion.answer"
                  :maxLength="255"
                  :placeholder="$t('maintenance.incidents.create.response_placeholder')"
                ></b-form-input>
              </div>
              <div v-if="selectedQuestion.response_type == 'Multi line text'">
                <b-form-textarea
                  qid="create-m-form-description"
                  v-model="selectedQuestion.answer"
                  rows="6"
                  max-rows="6"
                  :placeholder="$t('maintenance.incidents.create.response_placeholder')"
                ></b-form-textarea>
              </div>
              <div v-if="selectedQuestion.response_type == 'Datepicker'">
                <datepicker
                    class="date-picker"
                    qid="filter-s-form-modified-from"
                    calendar-class="right"
                    v-model="selectedQuestion.answer"
                    :clear-button="true"
                    :placeholder="$t('activities.create.modified_by_date_from_placeholder')"
                ></datepicker>
              </div>
              <div v-if="selectedQuestion.response_type == 'Attachment'">

              </div>
              <div v-if="selectedQuestion.response_type == 'Dropdown'">
                <multiselect
                    v-model="selectedQuestion.answer"
                    :options="selectedQuestion.answer_options"
                    :multiple="false"
                    label="title"
                    :taggable="false"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('tasks.modal.response_placeholder')"
                ></multiselect>
              </div>
              <div v-if="selectedQuestion.response_type == 'Yes/No'">
                <multiselect
                    v-model="selectedQuestion.answer"
                    :options="selectedQuestion.answer_options"
                    :multiple="false"
                    :taggable="false"
                    label="title"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('tasks.modal.response_placeholder')"
                ></multiselect>
              </div>
              <div v-if="selectedQuestion.response_type == 'System'">
                <multiselect
                    v-model="selectedQuestion.answer"
                    :options="systems"
                    :multiple="false"
                    :taggable="false"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('tasks.modal.response_placeholder')"
                ></multiselect>
              </div>

            </div>

          </div>
        </div>

      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-5">

              </div>
              <div class="col-sm-7">
                <div class="text-right">
                  <b-button v-if="position == 1"
                            variant="secondary"
                            class="mt-2"
                            @click="hideCreateIncidentModal"
                            qid="create-m-cancel-button"
                  >
                    {{ $t('maintenance.measures.create.cancel') }}
                  </b-button>
                  <b-button @click="previousView()"
                            class="mt-2"
                            variant="secondary"
                            v-if="position > 1"
                            qid="create-p-submit-button"
                  >
                    {{ $t('system.back') }}
                  </b-button>
                  <b-button @click="nextView()"
                            class="ml-3 mt-2"
                            variant="success"
                            v-if="position < 3 || (questions && questions.length && questionIndex + 1 != questions.length)"
                            :disabled="!selectedIncidentCategory.id || (position > 2 && selectedQuestion.mandatory_type && selectedQuestion.mandatory_type == 'Mandatory' && selectedQuestion.answer != '')"
                            qid="create-p-submit-button"
                  >
                    {{ $t('system.next') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3 mt-2"
                            variant="success"
                            @click="createIncidentFormSubmit"
                            :disabled="buttonDisabled"
                            v-if="questions && questions.length && questionIndex + 1 == questions.length"
                            qid="create-m-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.measures.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </span>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Datepicker from 'vuejs-datepicker';

  export default {
    name: 'CreateIncidentModal',
    data: function() {
      return {
        form: {
          incident_category: '',
          short_name: '',
          description: '',
          name: '',
          email: '',
          phone: '',
          links: []
        },
        systems: [],
        answers: [],
        answerOptions: [],
        position: 1,
        questionIndex: 0,
        answerValue: '',
        questions: [],
        showFullDescription: false,
        questionsLoading: false,
        selectedQuestion: {},
        selectedIncidentCategory: [],
        yesNoOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0},
        ],
        incidentCategoryItems: [],
        selectedCA: [],
        buttonDisabled: false,
        error: '',
        includeScheduled: 0,
        projectLoading: false,
        showFullProjectRunMessage: false,
        showFullProjectMessage: false,
        showUsersModal: false,
        selectedFiles: [],
        inputLink: '',
        inputLinkName: '',
        showDocuments: false,
        showAttachments: false,
        includeAttachments: 1,
        myGuides: [],
        wpGuide: {},
        showFullGuideDescription: false,
      }
    },
    props: {

    },
    components: {
      Datepicker
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getWordpressLink() {
        return this.$store.state.wordpressLink
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    watch: {
      getClient: function () {

      },
      includeScheduled: function () {
        this.loadCA()
      }
    },
    methods: {
      showCreateIncidentModal() {
        var moment = require('moment');
        this.loadIncidentCategories()
        this.error = '';
        this.questionIndex = 0
        this.position = 1
        this.selectedQuestion = {}
        this.selectedIncidentCategory = []
        this.$refs['create-incident'].show()
      },
      hideCreateIncidentModal() {
        this.selectedCA = []
        this.form.start_date = ''
        this.form.due_date = ''
        this.form.links = [];
        this.inputLink = '';
        this.selectedFiles = [];
        this.form.schedule_message = ''
        this.$refs['create-incident'].hide()
      },
      resetFile() {
        let imagefile = document.querySelector('#file-rr');
        imagefile.value = '';
      },
      previousView() {
        let self = this;
        this.error = ''

        if (this.position == 1) {

        } else if (this.position == 2) {
          this.position -= 1
        } else {
          this.questionIndex = _.findIndex(self.questions, function(o) { return o.id == self.selectedQuestion.id })
          if (this.questionIndex > 0) {
            this.selectedQuestion = this.questions[this.questionIndex - 1]
            this.questionIndex -=1
          } else {
            this.position -= 1
            this.selectedQuestion = this.questions[0]
            this.questionIndex = 0
          }
        }

      },
      nextView() {
        let self = this;
        this.error = ''

        if (this.position == 1) {
          this.position += 1
          this.loadQuestions()
          this.loadSystems()
        } else if (this.position == 2){
          this.position += 1
          this.selectedQuestion = this.questions[0]
          this.questionIndex = 0
        } else {
          this.questionIndex = _.findIndex(self.questions, function(o) { return o.id == self.selectedQuestion.id })

          if (this.questionIndex < this.questions.length - 1) {
            this.selectedQuestion = this.questions[this.questionIndex + 1]
            this.questionIndex +=1
          } else {
            this.selectedQuestion = this.questions[0]
            this.questionIndex = 0
          }

        }

      },
      onFileChange() {
        let files = document.querySelector('#file-rr');
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i])
        }
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.form.links.push({url: this.inputLink, name: this.inputLinkName})
          // Reset link input form
          this.inputLink = ''
          this.inputLinkName = ''
        }
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.form.links.splice(index, 1);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Maintenance' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Maintenance',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
            piincHttp.get(self.getWordpressLink + self.myGuides[0].external_id).then(function(response) {
              self.wpGuide = response.data
            }, function() {});
          }
        }, function() {});
      },
      createIncidentFormSubmit(evt) {
        var moment = require('moment');
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        let sizeError = false;
        //let files = document.querySelector('#file-rr');

        // Call handle link function to gather link from link input
        this.handleLink()

        let formData = new FormData();

        // // Append list of attachments to FormData
        // for (var i = 0; i < files.files.length; i++) {
        //   // Equal to 10 MB
        //   if (files.files[i].size > 10485760) {
        //     sizeError = true;
        //   }
        //   formData.append("files[]", files.files[i]);
        // }

        // Append list of links to FormData
        for (var i = 0; i < this.form.links.length; i++) {
          formData.append("links[]", JSON.stringify(this.form.links[i]));
        }

        // Append list of answers to FormData
        for (var i = 0; i < this.questions.length; i++) {
          formData.append("answers[]", JSON.stringify(
            {
              question_id: this.questions[i].id,
              answer: this.questions[i].answer
            }
          ));
        }

        if (this.selectedIncidentCategory && this.selectedIncidentCategory.id) {
          formData.append("incident_category", this.selectedIncidentCategory.id);
        }

        formData.append("include_attachments", this.includeAttachments);

        formData.append("short_name", this.form.short_name);

        formData.append("name", this.form.name);
        formData.append("email", this.form.email);
        formData.append("phone", this.form.phone);

        if (sizeError) {
          this.error = this.$t('system.file_size')
          this.buttonDisabled = false;
        } else {
          this.buttonDisabled = true;

          piincHttp.post('incidents', formData, {

          }).then(function(response) {
            self.hideCreateProjectModal();
            self.$emit('reloadContent', response.data);
            self.$toastr('success', self.$t('projects.create.project_success'))
            self.buttonDisabled = false;
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
              if (error.data.errors.start_date) {
                self.error += ' ' + error.data.errors.start_date[0]
              }
              if (error.data.errors.due_date) {
                self.error += ' ' + error.data.errors.due_date[0]
              }
            }
          })
        }

      },
      loadIncidentCategories(query) {
        let self = this;
        this.projectLoading = true
        piincHttp.get('incident-categories', { params:
          {
            per_page: 100,
            client: this.getClient.slug,
          }
        }).then(function(response) {
          self.projectLoading = false
          self.incidentCategoryItems = response.data.items
          if (self.incidentCategoryItems && !self.incidentCategoryItems.length && !query) {
            self.incidentCategoryItems.push({title: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      loadSystems(query) {
        let self = this;
        this.projectLoading = true
        piincHttp.get('systems', { params:
          {
            per_page: 100,
            client: this.getClient.slug,
          }
        }).then(function(response) {
          self.projectLoading = false
          self.systems = response.data.items
          if (self.systems && !self.systems.length && !query) {
            self.systems.push({title: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      loadQuestions(query) {
        let self = this;
        this.questionsLoading = true
        piincHttp.get('incident-category-questions', { params:
          {
            per_page: 100,
            incident_category: this.selectedIncidentCategory.id,
          }
        }).then(function(response) {
          self.questionsLoading = false

          _.forEach(response.data.items, function (item) {
            item.answer = ''
            item.answer_options = JSON.parse(item.response_type_options)
          })

          self.questions = response.data.items
        }, function() {});
      }
    },
    created () {
      this.loadGuides('create_incident');
    }
  }
</script>
